import { RestRequest, } from '@Utils';
import { IPreviewAiRequest, ISharedAiRequest, } from 'atlas-shared';

export const fetchAiRequest = async (organization_id: IPreviewAiRequest['organization_id'], id: IPreviewAiRequest['id']): Promise<ISharedAiRequest> => {
  return RestRequest.get<ISharedAiRequest>(`ai_request/p/${organization_id}/${id}`, { socket_id: global.socketId, });
};
